<template>
  <div id="custom-dashboard" class="custom-dashboard">
    <div
      v-if="isLoading"
      ref="loader-container"
      class="custom-dashboard__loader"
      :style="loaderStyle"
    >
      <img class="blinker" :src="getAsset('secondaryLogo', 'sidebarMinimize')" width="60" />
    </div>

    <iframe
      v-show="!isLoading"
      :id="id"
      v-resize="{ log: true }"
      class="custom-dashboard__frame"
      :style="frameStyle"
      :src="link"
      @load="isLoading = false"
    />
  </div>
</template>

<script>
import iframeResize from 'iframe-resizer/js/iframeResizer'
import { mapGetters } from 'vuex'

export default {
  directives: {
    resize: {
      bind: function (el, { value = {} }) {
        el.addEventListener('load', () => iframeResize(value, el))
      },
      unbind: function (el) {
        el.iFrameResizer.removeListeners()
      },
    },
  },
  props: {
    id: {
      type: String,
    },
    link: {
      type: String,
    },
  },
  data() {
    return {
      loaderStyle: {},
      frameStyle: {
        width: '100%',
      },
      isLoading: true,
    }
  },
  computed: {
    ...mapGetters({
      getAsset: 'asset/getAsset',
    }),
  },
  mounted() {
    const loader = this.$refs['loader-container']
    this.$set(this.loaderStyle, 'height', `${window.innerHeight - (loader.offsetTop + 150)}px`)
  },
}
</script>

<style lang="scss">
.custom-dashboard {
  &__loader {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__frame {
    border: none;
  }
}

@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.blinker {
  animation: blink 1s infinite;
}
</style>
